export enum MentoringPoints {
  GET_REQUEST = 'tutorship/tutoredRequest/get',
  POST_REQUEST = 'tutorship/tutoredRequest/create',
  GET_TEAMS = 'tutorship/tutorTutoreds/get',
  GET_PROGRAMS = 'tutorship/program/get',
  GET_MEETING = 'tutorship/tutorMeeting/get',
  GET_RESULT = 'tutorship/tutorMeetingResults/get',
  POST_MEETING = 'tutorship/tutorMeetingResultTutored/create',
}



// WEBPACK FOOTER //
// ./src/services/mentoring/types.ts